import { BUTTON_GROUP_ALIGNMENT as o } from "./button-group-constants.js";
import { createElementBlock as n, openBlock as a, normalizeClass as s, renderSlot as l } from "vue";
import { _ as p } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  compatConfig: { MODE: 3 },
  name: "DtButtonGroup",
  props: {
    /**
     * Alignment of the buttons inside the container
     */
    alignment: {
      type: String,
      default: "start",
      validator: (t) => Object.keys(o).includes(t)
    }
  },
  data() {
    return {
      BUTTON_GROUP_ALIGNMENT: o
    };
  }
};
function i(t, u, e, m, r, _) {
  return a(), n("div", {
    class: s([
      "d-btn-group",
      r.BUTTON_GROUP_ALIGNMENT[e.alignment]
    ]),
    role: "group"
  }, [
    l(t.$slots, "default")
  ], 2);
}
const N = /* @__PURE__ */ p(c, [["render", i]]);
export {
  N as default
};
//# sourceMappingURL=button-group.js.map
